import React, { FunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';
import { useFlags } from '../../../hooks/useFlags';
import IsPageOwner from '../../IsPageOwner/IsPageOwner';
import ManualFitnessEntry from '../../ManualFitnessEntry/ManualFitnessEntry';
import { ActivityTotalsFlags } from '../ActivityTotals';
import styles from './ActionLinks.scss';

interface ActionLinksProps {
  refetchTotals: () => void;
}

export const ActionLinks: FunctionComponent<ActionLinksProps> = ({
  refetchTotals,
}) => {
  const { t } = useTranslation('common', { useSuspense: false });
  const { virtualFitnessEventsBleedingEdge } = useFlags<ActivityTotalsFlags>();

  return (
    <div className={styles.container}>
      <IsPageOwner>
        <ManualFitnessEntry
          opener={({ onOpen }) => (
            <button className="jg-text--link" onClick={onOpen}>
              {t('activity.totals.actions.addProgress')}
            </button>
          )}
          onSubmit={refetchTotals}
        />
      </IsPageOwner>
      {virtualFitnessEventsBleedingEdge && (
        <button className="jg-text--link">{t('common.share')}</button>
      )}
    </div>
  );
};
